/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandYcombinator = createReactComponent("outline", "brand-ycombinator", "IconBrandYcombinator", [["path", { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M8 7l4 6l4 -6", "key": "svg-1" }], ["path", { "d": "M12 17l0 -4", "key": "svg-2" }]]);

export { IconBrandYcombinator as default };
//# sourceMappingURL=IconBrandYcombinator.mjs.map
